import { render, staticRenderFns } from "./SlidePromoFlexibleOld.vue?vue&type=template&id=211a151c&"
import script from "./SlidePromoFlexibleOld.vue?vue&type=script&lang=js&"
export * from "./SlidePromoFlexibleOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports